import React from 'react';

import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

import withStyles from "@material-ui/core/styles/withStyles";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import Switch from "@material-ui/core/Switch";
import Checkbox from "@material-ui/core/Checkbox";
import Datetime from 'react-datetime';

import Check from "@material-ui/icons/Check";
import Add from "@material-ui/icons/Add";

import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import { IconButton, Avatar } from '@material-ui/core';
import ReactSelect from '../../../components/Select/ReactSelect';
import UserImage from '../../../components/Image/UserImage';
import Api from '../../../api/Api.js';
import EmailEndpoints from '../../../api/EmailEndpoints';
import Accordion from '../../../components/Accordion/Accordion';
import moment from 'moment';
import NumberMaskInput from '../../../components/CustomInput/NumberMaskInput';

class RunConfigurationObject {
    run_now = false;
    runonce = false;
    active = false;
    billing = false;
    template = false;
    report_emails = [];
    report_users = [];
    mock_date = moment().startOf("day");
    delay_until = moment().startOf("day");
    run_mock = false;
    priority = 0;
    weight = 1;
}

const styles = {
    label: {
        color: '#777'
    }
}

const verifyEmail = (value) => {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
        return true;
    }
    return false;
}

class RunConfiguration extends React.Component {

    state = new RunConfigurationObject();

    getConfig = () => ({
        ...this.state,
        report_emails: null,
        report_users: null,
        mock_date: (this.state.mock_date && moment.isMoment(this.state.mock_date) && this.state.mock_date.format("YYYY-MM-DD HH:mm:ss")) || null,
        delay_until: (this.state.delay_until && moment.isMoment(this.state.delay_until) && this.state.delay_until.format("YYYY-MM-DD HH:mm:ss")) || null,
        emails: this.state.report_emails.map(x => ({ email_id: x.value })),
        users: this.state.report_users.map(x => ({ user_id: x.value }))
    });

    componentDidMount() {

        var newState = {};

        if (
            this.props.report
            &&
            this.props.report.emails
            &&
            this.props.report.emails.length > 0
            // && 
            // (!this.state.report_emails || this.state.report_emails.length === 0)
        ) {
            newState.report_emails = this.props.report.emails.map(e => ({ label: e.emailaddress, value: e.id }))
        }

        if (
            this.props.report
            &&
            this.props.report.users
            &&
            this.props.report.users.length > 0
            // && 
            // (!this.state.report_emails || this.state.report_emails.length === 0)
        ) {
            newState.report_users = this.props.report.users.map(u => ({ label: u.name + (u.surname ? " " + u.surname : ''), avatar: <Avatar><UserImage {...u} /></Avatar>, value: u.id }))
        }

        if (this.props.report) {
            this.setState({ ...this.props.report, mock_date: this.props.report.mock_date || moment().startOf("year"), ...newState });
        }
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.report
            &&
            this.props.report.emails
            &&
            (!prevProps.report || !prevProps.report.emails || this.props.report.emails.length !== prevProps.report.emails.length)
            &&
            this.props.report.emails.length > 0
            &&
            (!this.state.report_emails || this.state.report_emails.length === 0)
        ) {
            this.setState({ report_emails: this.props.report.emails.map(e => ({ label: e.emailaddress, value: e.id })) })
        }

        if (
            this.props.report
            &&
            this.props.report.users
            &&
            (!prevProps.report || !prevProps.report.users || this.props.report.users.length !== prevProps.report.users.length)
            &&
            this.props.report.users.length > 0
            &&
            (!this.state.report_users || this.state.report_users.length === 0)
        ) {
            this.setState({ report_users: this.props.report.users.map(u => ({ label: u.name + (u.surname ? " " + u.surname : ''), avatar: <Avatar><UserImage {...u} /></Avatar>, value: u.id })) })
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <GridContainer>
                <GridItem xs={12}>
                    <div className={classes.checkboxAndRadio}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.run_now}
                                    onChange={() => this.setState({ run_now: !this.state.run_now })}
                                    tabIndex={-1}
                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                    icon={<Check className={classes.uncheckedIcon} />}
                                    classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot
                                    }}
                                />
                            }
                            classes={{
                                label: classes.label
                            }}
                            label="Run Immediately"
                        />
                    </div>

                    <div className={classes.block}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={this.state.runonce}
                                    onChange={() => this.setState({ runonce: !this.state.runonce })}
                                    classes={{
                                        switchBase: classes.switchBase,
                                        checked: classes.switchChecked,
                                        icon: classes.switchIcon,
                                        iconChecked: classes.switchIconChecked,
                                        bar: classes.switchBar
                                    }}
                                />
                            }
                            classes={{
                                label: classes.label
                            }}
                            label="Run Once &amp; Disable"
                        />
                    </div>

                    <div className={classes.block}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={this.state.active}
                                    onChange={() => this.setState({ active: !this.state.active })}
                                    classes={{
                                        switchBase: classes.switchBase,
                                        checked: classes.switchChecked,
                                        icon: classes.switchIcon,
                                        iconChecked: classes.switchIconChecked,
                                        bar: classes.switchBar
                                    }}
                                />
                            }
                            classes={{
                                label: classes.label
                            }}
                            label="Active"
                        />
                    </div>
                    <hr />
                    {/* Emails */}

                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                        <div style={{ flex: 1 }}>
                            <ReactSelect
                                label="Email Recipients"
                                options={
                                    this.props.emails && this.props.emails.length > 0 ?
                                        this.props.emails.map(e => ({ label: e.emailaddress, value: e.id }))
                                        :
                                        [{ label: 'Loading...', value: '' }]
                                }
                                onChange={(value) => this.setState({ report_emails: value })}
                                isValidNewOption={verifyEmail}
                                onCreateOption={(new_email) => {
                                    Api.get(EmailEndpoints.add, { email: new_email })
                                        .then(({ data }) => {
                                            this.setState({ report_emails: this.state.report_emails.concat([{ label: data.emailaddress, value: data.id }]) }, () => this.props.emailCreated(data));
                                        });
                                }}
                                placeholder="No Emails Selected"
                                value={this.state.report_emails}
                                isCreateable
                                isClearable
                                isSearchable
                                isMulti
                                isLoading={!this.props.emails || this.props.emails.length === 0}
                                isDisabled={!this.props.emails || this.props.emails.length === 0}
                            />
                        </div>
                        <IconButton onClick={() => this.props.onEmailOpenClick()}>
                            <Add />
                        </IconButton>
                    </div>
                    <hr />
                    {/* Users */}

                    <ReactSelect
                        label="Users Allowed to View"
                        options={
                            this.props.users && this.props.users.length > 0 ?
                                this.props.users.map(u => ({ label: u.name + (u.surname ? " " + u.surname : ''), avatar: <UserImage {...u} />, value: u.id }))
                                :
                                [{ label: 'Loading...', value: '' }]
                        }
                        onChange={(value) => this.setState({ report_users: value })}
                        placeholder="No Users Selected"
                        value={this.state.report_users}
                        isClearable
                        isSearchable
                        isMulti
                        isLoading={!this.props.users || this.props.users.length === 0}
                        isDisabled={!this.props.users || this.props.users.length === 0}
                    />

                    <Accordion
                        collapses={
                            [
                                {
                                    title: "MOCK Run",
                                    content: (
                                        <div>

                                            <div className={classes.block}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={this.state.run_mock}
                                                            onChange={() => this.setState({ run_mock: !this.state.run_mock })}
                                                            classes={{
                                                                switchBase: classes.switchBase,
                                                                checked: classes.switchChecked,
                                                                icon: classes.switchIcon,
                                                                iconChecked: classes.switchIconChecked,
                                                                bar: classes.switchBar
                                                            }}
                                                        />
                                                    }
                                                    classes={{
                                                        label: classes.label
                                                    }}
                                                    label="Run Mock"
                                                />
                                            </div>

                                            <FormControl fullWidth>
                                                <InputLabel
                                                    htmlFor="mock_date"
                                                    style={{
                                                        top: -8,
                                                        color: '#AAAAAA !important',
                                                        fontSize: 14,
                                                        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                                                        fontWeight: 400,
                                                        lineHeight: 1.42857
                                                    }}
                                                    shrink
                                                >
                                                    MOCK Date</InputLabel>
                                                <Datetime
                                                    id="mock_date"
                                                    inputProps={{ placeholder: "MOCK Date", id: 'mock_date' }}
                                                    dateFormat={"YYYY-MM-DD"}
                                                    timeFormat={"HH:mm"}
                                                    timeConstraints={{ minutes: { step: 5 } }}
                                                    value={this.state.mock_date}
                                                    onChange={(val) => this.setState({ mock_date: val })}
                                                />
                                            </FormControl>
                                        </div>
                                    )
                                },
                                {
                                    title: "Misc",
                                    content: (
                                        <div>
                                            {/* TODO: Move to Schedule Manager as Start Date and Add End Date Variable */}
                                            <FormControl fullWidth>
                                                <InputLabel
                                                    htmlFor="delay_until"
                                                    style={{
                                                        top: -8,
                                                        color: '#AAAAAA !important',
                                                        fontSize: 14,
                                                        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                                                        fontWeight: 400,
                                                        lineHeight: 1.42857
                                                    }}
                                                    shrink
                                                >
                                                    Delay Start</InputLabel>
                                                <Datetime
                                                    id="delay_until"
                                                    inputProps={{ placeholder: "Delay Start", id: 'delay_until' }}
                                                    dateFormat={"YYYY-MM-DD"}
                                                    timeFormat={"HH:mm"}
                                                    timeConstraints={{ minutes: { step: 5 } }}
                                                    value={this.state.delay_until}
                                                    onChange={(val) => this.setState({ delay_until: val })}
                                                />
                                            </FormControl>

                                            <NumberMaskInput
                                                type="number"
                                                labelText="Priority"
                                                id="priority"
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    onChange: event => this.setState({ priority: event.target.value }),
                                                    value: this.state.priority,
                                                }}
                                            />

                                            <NumberMaskInput
                                                type="number"
                                                labelText="Weight"
                                                id="weight"
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    onChange: event => this.setState({ weight: event.target.value }),
                                                    value: this.state.weight,
                                                }}
                                            />

                                            <div className={classes.block}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={this.state.billing}
                                                            onChange={() => this.setState({ billing: !this.state.billing })}
                                                            classes={{
                                                                switchBase: classes.switchBase,
                                                                checked: classes.switchChecked,
                                                                icon: classes.switchIcon,
                                                                iconChecked: classes.switchIconChecked,
                                                                bar: classes.switchBar
                                                            }}
                                                        />
                                                    }
                                                    classes={{
                                                        label: classes.label
                                                    }}
                                                    label="Activate as Billing Report"
                                                />
                                            </div>

                                            <div className={classes.block}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={this.state.template}
                                                            onChange={() => this.setState({ template: !this.state.template })}
                                                            classes={{
                                                                switchBase: classes.switchBase,
                                                                checked: classes.switchChecked,
                                                                icon: classes.switchIcon,
                                                                iconChecked: classes.switchIconChecked,
                                                                bar: classes.switchBar
                                                            }}
                                                        />
                                                    }
                                                    classes={{
                                                        label: classes.label
                                                    }}
                                                    label="Activate as Template Report (Can be duplicated based on paramaters)"
                                                />
                                            </div>
                                        </div>
                                    )
                                }
                            ]
                        }
                    />
                </GridItem>
            </GridContainer>
        );
    }
}

export default withStyles({ ...regularFormsStyle, ...extendedFormsStyle, ...styles })(RunConfiguration);
